import { CanvasService } from 'appworks/graphics/canvas/canvas-service';
import { Services } from 'appworks/services/services';
import { UI } from 'appworks/ui/ui';
import { FPSMeterService } from 'fps-meter-service';
import { FowlSetup } from 'setup/fowl-setup';
import { SlingoGameInstanceIdControl } from 'slingo/ui/controls/slingo-game-instance-id-control';
import { SlingoGameInstanceIdControlFactory } from 'slingo/ui/factories/slingo-game-instance-id-control-factory';
import { setupComponents } from './social-component-setup';
import { FowlStateSetup } from './social-fowl-state-setup';

/**
 * Sets up social additions
 *
 * @class SocialSetup
 * @typedef {SocialSetup}
 * @extends {PYLSetup}
 */
export class SocialSetup extends FowlSetup {
  /**
   * Social components
   *
   * @public
   * @override
   */
  public setupComponents(): void {
    setupComponents();
  }

  /**
   * Social Ui setup
   *
   * @public
   * @override
   */
  public setupUI(): void {
    super.setupUI();
    UI.deregister(SlingoGameInstanceIdControlFactory);
    SlingoGameInstanceIdControl.showGameId = false;
  }

  /**
   * Social state setup
   *
   * @public
   * @override
   */
  public setupStates(): void {
    FowlStateSetup()
  }

  /**
   * Social services
   *
   * @public
   * @override
   */
  public setupServices(): void {
    super.setupServices();
    Services.register(new FPSMeterService());
  }

  /**
   * Social canvas setup
   *
   * @public
   * @override
   */
  public setupCanvas(): void {
    super.setupCanvas();
    Services.get(CanvasService).fullScreenEnabled = false;
  }
}
